export default "__VITE_ASSET__7b5b845c__"